var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticStyle: {
      "margin-top": "75px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n\t\t\t员工离职-详情")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 40px 0 40px",
      "height": "800px",
      "background-color": "#FFFFFF"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.staff.staff_name))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("身份证号码：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.staff.staff_card))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.staff.staff_telephone))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("入职日期：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.staff.induction_time))])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("组织架构：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.staff.range))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("城市：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.staff.city_id))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("职位：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.staff.post_name))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("入职薪酬：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.staff.induction_salary))])], 1)], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("离职日期：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.quit_date))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("离职原因：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.dictionaries_data))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("离职提交日期：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.quit_time))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("操作人：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.operator))])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ruleForm.remarks == null || _vm.ruleForm.remarks == '' ? '无' : _vm.ruleForm.remarks))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('lable', {
    staticClass: "label"
  }, [_vm._v("离职审批表：")]), _vm._v(" "), _c('el-image', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.ruleForm.quit_url
    }
  })], 1)], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('el-row', [_c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin": "20px 10%"
    },
    attrs: {
      "data": _vm.ruleForm.staff.dangerList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "dangerType",
      "align": "center",
      "label": "保险类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "danger_dete",
      "align": "center",
      "label": "出险时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "indemnity_amount",
      "align": "center",
      "label": "赔付金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "settlement_status",
      "align": "center",
      "label": "理赔状态"
    }
  })], 1)], 1)], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border-left": "3px #006E48 solid",
      "margin-left": "5%",
      "border-bottom": "1px #f8f8f8 solid",
      "margin-right": "5%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("基础信息")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border-left": "3px #006E48 solid",
      "margin-top": "60px",
      "margin-left": "5%",
      "border-bottom": "1px #f8f8f8 solid",
      "margin-right": "5%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("离职信息")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border-left": "3px #006E48 solid",
      "margin-top": "60px",
      "margin-left": "5%",
      "border-bottom": "1px #f8f8f8 solid",
      "margin-right": "5%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("保险信息")])])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d7a77e6","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Yglz/Yglz_edit.vue
// module id = null
// module chunks = 